export const getPlaybackProgress = (progress?: number) =>
  progress ? Math.round(progress * 100) : 0

export const isWatched = (progress?: number) => progress === 1
